<template>
  <div class="login-wrapper">
    <el-card class="login-box result-card">
      <div class="icon-wrapper">
        <svg class="icon success-anim" aria-hidden="true">
          <use xlink:href="#icon-chenggong"></use>
        </svg>
      </div>

      <div class="result-header">
        <h2 class="accountinfo">邮件已发送</h2>
        <p class="email-display">{{ email }}</p>
      </div>

      <div class="notice-box">
        <p class="main-notice">
          请在 <span class="highlight">10分钟内</span> 登录邮箱查看更改密码邮件。
        </p>
        <p class="sub-notice">
          点击邮件中的链接即可重置密码。若未收到邮件，请检查垃圾箱，或确认邮箱填写是否正确。
        </p>
      </div>

      <div class="action-area">
        <el-button type="primary" class="back-btn" @click="background">返回登录页面</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import "../assets/fonts/iconfont.js";
export default {
  data() {
    return {
      email: ""
    }
  },
  created() {
    // 从 sessionStorage 获取找回密码时存入的邮箱
    this.email = window.sessionStorage.getItem("forget") || "您的邮箱"
  },
  methods: {
    background() {
      this.$router.push('/login')
    }
  }
};
</script>

<style lang="less" scoped>
/* 1. 基础容器：保持全系统统一的渐变背景 */
.login-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  box-sizing: border-box;
}

/* 2. 卡片容器：统一宽度与圆角 */
.login-box {
  width: 420px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  border: none;
  padding: 20px;
  text-align: center;
}

/* 3. 图标样式 */
.icon-wrapper {
  margin-top: 20px;
  .icon {
    width: 80px;
    height: 80px;
    fill: #67c23a; /* 成功绿 */
    margin: 0 auto;
    display: block;
  }
}

/* 4. 标题与邮箱信息 */
.result-header {
  margin: 20px 0;
  .accountinfo {
    font-size: 24px;
    color: #303133;
    margin-bottom: 8px;
    font-weight: 600;
  }
  .email-display {
    font-size: 16px;
    color: #606266;
    word-break: break-all;
  }
}

/* 5. 提示框样式：将原本的红色改为更专业的警告/提示色块 */
.notice-box {
  background-color: #f0f9eb; /* 浅绿背景，表示步骤进展顺利但需要注意 */
  border: 1px solid #e1f3d8;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  text-align: left;
  
  .main-notice {
    color: #67c23a;
    font-weight: bold;
    margin-bottom: 8px;
    font-size: 14px;
    .highlight {
      color: #f56c6c; /* 时间限制用红色强调 */
      text-decoration: underline;
    }
  }
  .sub-notice {
    color: #909399;
    font-size: 13px;
    line-height: 1.6;
  }
}

/* 6. 按钮区域 */
.action-area {
  margin-bottom: 10px;
  .back-btn {
    width: 100%;
    height: 42px;
    font-size: 16px;
    border-radius: 8px;
    letter-spacing: 1px;
  }
}

/* 7. 移动端自适应 */
@media screen and (max-width: 768px) {
  .login-wrapper {
    background: #ffffff;
    align-items: flex-start;
    padding-top: 10vh;
  }
  .login-box {
    width: 100%;
    box-shadow: none;
  }
}
</style>